import { useFetcher } from "./api"

export const useGetActivities = ({ refetchOnMount = true, enabled = true }: any) => {
    return useFetcher<any, any>({ key: `user-activity`, path: `/user/activity`, refetchOnMount, enabled });
}